import { globalActions } from '../../global-actions';

export const actionTypes = {
  AUTH_START: 'AUTH_START',
  AUTH_END: 'AUTH_END',
  REFRESH_START: 'REFRESH_START',
  REFRESH_SUCCESS: 'REFRESH_SUCCESS',
  REFRESH_FAILURE: 'REFRESH_FAILURE',
};

export const actions = {
  authStart: () => {
    globalActions.next({
      type: actionTypes.AUTH_START,
    });
  },
  authEnd: (isUserLogged, userToken = '') => {
    globalActions.next({
      type: actionTypes.AUTH_END,
      payload: {
        isUserLogged,
        userToken,
      },
    });
  },
  refreshStart: () => {
    globalActions.next({
      type: actionTypes.REFRESH_START,
    });
  },
  refreshSuccess: (userToken) => {
    globalActions.next({
      type: actionTypes.REFRESH_SUCCESS,
      payload: {
        userToken,
      },
    });
  },
  refreshFailure: (error) => {
    globalActions.next({
      type: actionTypes.REFRESH_FAILURE,
      payload: {
        error,
      },
    });
  },
};
